"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var operators_1 = require("rxjs/operators");
var publish_data_model_1 = require("../report-publish-dialog/publish-data.model");
var from_1 = require("rxjs/observable/from");
var HttpPublishService = /** @class */ (function () {
    function HttpPublishService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.publishPath = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/publish/widgets"], ["", "/publish/widgets"])), 'serviceUri');
        this.idmPageServiceUrl$ = from_1.from(this.applicationPropertiesService.getProperty(HttpPublishService_1.PAGE_SERVICE_NAME));
    }
    HttpPublishService_1 = HttpPublishService;
    HttpPublishService.prototype.get = function (widgetId, languageId) {
        var _this = this;
        var params = new http_1.HttpParams()
            .set('languageId', languageId.toString());
        var urlOfRequest = '';
        var baseUrl = '';
        return this.idmPageServiceUrl$
            .pipe(operators_1.switchMap(function (url) {
            urlOfRequest = _this.publishPath.replaceTemplate({
                serviceUri: url,
            });
            baseUrl = url;
            return _this.http.get(urlOfRequest + '/' + widgetId, { params: params });
        }), operators_1.map(function (data) {
            var publishData = new publish_data_model_1.PublishData(null, null, null, null, new publish_data_model_1.Schedule(), null);
            publishData.deserialize(data);
            publishData.navigationUrl = baseUrl + '/published-reports/' + publishData.url;
            return publishData;
        }));
    };
    HttpPublishService.prototype.delete = function (id) {
        var _this = this;
        this.idmPageServiceUrl$
            .pipe(operators_1.switchMap(function (url) {
            var urlOfRequest = _this.publishPath.replaceTemplate({
                serviceUri: url,
            });
            return _this.http.delete(urlOfRequest + '/' + id);
        }));
    };
    HttpPublishService.prototype.create = function (publishData, languageId) {
        var _this = this;
        var params = new http_1.HttpParams()
            .set('languageId', languageId.toString());
        return this.idmPageServiceUrl$
            .pipe(operators_1.switchMap(function (url) {
            var urlOfRequest = _this.publishPath.replaceTemplate({
                serviceUri: url,
            });
            publishData.navigationUrl = url + '/published-reports/';
            return _this.http.post(urlOfRequest, publishData.serialize(), { params: params });
        }));
    };
    HttpPublishService.prototype.update = function (publishData, languageId) {
        var _this = this;
        var params = new http_1.HttpParams()
            .set('languageId', languageId.toString());
        return this.idmPageServiceUrl$
            .pipe(operators_1.switchMap(function (url) {
            var urlOfRequest = _this.publishPath.replaceTemplate({
                serviceUri: url,
            });
            publishData.navigationUrl = url + '/published-reports/';
            return _this.http.put(urlOfRequest + '/' + publishData.id, publishData.serialize(), { params: params });
        }));
    };
    var HttpPublishService_1;
    HttpPublishService.PAGE_SERVICE_NAME = 'page-service-url';
    HttpPublishService = HttpPublishService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpPublishService);
    return HttpPublishService;
}());
exports.HttpPublishService = HttpPublishService;
var templateObject_1;
//# sourceMappingURL=http-publish.service.js.map